import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import win11StartDarkBackground from './assets/win11-start-dark-bgimage.svg';
import { getStartStyles } from './styles/win11-start-dark-style';


export const Win11StartDark = ({
  styleOverrides,
}) => {
  const classes = useDefaultStyles(getStartStyles({ styleOverrides }));

  return (
    <div className={classnames('win-start-background', classes.startBackground)}>
      <img className={classnames('win-start-background-image', classes.background)} alt="" src={win11StartDarkBackground} />
      <div className={classnames('win-start-ad-container', classes.adContainer)} />
    </div>
  );
};

Win11StartDark.propTypes = {
  styleOverrides: PropTypes.shape({}),
};

Win11StartDark.defaultProps = {
  styleOverrides: {},
};
